module.exports = __webpack_public_path__ + "img/facebook-white.ca3fbb14.svg";